enum ComposeLinkPreviewMode {
    None,
    Edit,
    Selected,
}

export default ComposeLinkPreviewMode;
